import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import moment from "moment";
import { handleCreateSubmit } from "./editSrf/submitHandlers";
import { ToastContainer, toast } from "react-toastify";
import { generateNumber } from "../../utils/utils";

export const buildServiceReqFromOld = ({
  newServiceReqNumberFormat,
  newEntryDate,
  serviceReqNumber,
}) => {
  if (!serviceReqNumber || !newServiceReqNumberFormat) return serviceReqNumber;

  const token = [
    "DDMMYYYY",
    "YYYYMMDD",
    "YYYY/MM/DD",
    "DD/MM/YYYY",
    "DDMMYY",
    "YYMMDD",
    "YYMM",
    "MMYY",
    "DDMM",
    "DDYY",
  ].find((t) => newServiceReqNumberFormat.includes(t));

  return token
    ? serviceReqNumber.replace(
        /\b\d{4,8}\b/,
        moment(newEntryDate).format(token),
      )
    : serviceReqNumber;
};

export const handleSrfCopy = async (
  id,
  settings,
  updateSrfDetails,
  props,
  openErrorModal,
  newEntryDate,
  newCalibrationDate,
) => {
  const url = `${BASE_URL}dynamic`;
  try {
    localStorage.setItem("isCopySRF", "true");
    // Fetch SRF + Instruments in parallel
    const [srfRes, instrumentsRes, serviceReqNumberFormat] = await Promise.all([
      axiosWithToken.post(url, {
        query: `SELECT * FROM srfs WHERE id = ${id} AND status = 1`,
      }),
      axiosWithToken.post(url, {
        query: `SELECT * FROM srfInstruments WHERE srfsId = ${id} AND status = 1`,
      }),
      axiosWithToken.post(url, {
        query: `SELECT * FROM settings WHERE keyName = 'serviceReqNumberNABL' AND status = 1`,
      }),
    ]);

    const srfData = srfRes.data?.[0] || {};
    const instrumentsData = instrumentsRes.data || [];
    const oldInstrumentIds = instrumentsData.map(({ id }) => id);
    const newServiceReqNumberFormat = serviceReqNumberFormat?.data?.[0]?.value;

    // Prepare SRF details
    const {
      id: _,
      lastModified,
      entryDate,
      receiptDate,
      serviceReqNumber,
      contactPersonDetails,
      extraColumns,
      ...rest
    } = srfData;

    const updatedServiceReqNumber = buildServiceReqFromOld({
      newServiceReqNumberFormat,
      newEntryDate,
      serviceReqNumber,
    });

    const srfDetails = {
      ...rest,
      serviceReqNumber: updatedServiceReqNumber,
      extraColumns: extraColumns && JSON.parse(extraColumns),
      contactPersonDetails:
        contactPersonDetails && JSON.parse(contactPersonDetails),
      entryDate: moment(newEntryDate).format("YYYY-MM-DD"),
      receiptDate: moment(newEntryDate).format("YYYY-MM-DD"),
      branch: serviceReqNumber?.split("/")[1]?.trim() || "",
    };

    // Prepare instruments rows
    const readingRows = instrumentsData.map(
      ({
        id,
        lastModified,
        srfsId,
        customerAnnextureFilePaths,
        extraColumns,
        ...rest
      }) => ({
        ...rest,
        id: 0,
        extraColumns: extraColumns && JSON.parse(extraColumns),
        customerAnnextureFilePaths:
          customerAnnextureFilePaths?.split(",") || [],
      }),
    );

   // Create new SRF + instruments
    const srfInstrumentIdsList = await handleCreateSubmit(
      srfDetails,
      readingRows,
      settings,
      props.setLoader,
      [],
      openErrorModal,
      "120",
      updateSrfDetails,
      "",
      true
    );

    // Fetch old readings
    const { data: allOldReading } = await axiosWithToken.post(url, {
      query: `SELECT * FROM datasheetStaticReadings WHERE datasheetId IN (${oldInstrumentIds.join(",")}) `,
    });

    // Map old IDs -> new IDs
    const readingIdObj = Object.fromEntries(
      oldInstrumentIds.map((id, i) => [id, srfInstrumentIdsList?.[i]]).filter(([, v]) => v != null)
    );

    // Replace datasheetId if mapping exists & remove id key
    const updatedReadings = allOldReading?.map(({ id, ...rest }) => ({
      ...rest,
      datasheetId: readingIdObj[rest.datasheetId] || rest.datasheetId,
    }));

    // Submit new readings if any
    if (updatedReadings?.length) {
      try {
        await axiosWithToken.post(`${BASE_URL}datasheetStaticReadings/bulk`, updatedReadings);
        toast.success("Datasheet Readings submitted successfully!");
      } catch (err) {
        toast.error(err?.response?.data?.message || "Failed to submit Datasheet Readings!");
        console.error("Bulk insert error:", err);
      }
    }
  } catch (error) {
    console.error("Error copying SRF:", error);
    toast.error("Failed to copy SRF!");
  } finally {
    localStorage.setItem("isCopySRF", "false");
    props.setLoader(false);
  }
};
